// ServiceWorkerChores.js
import { connect } from 'react-redux';
import ServiceWorkerChores from '../component/ServiceWorkerChores.jsx';
import getOperationData from '../selector/getOperationData.js';
import updateServiceWorkStatus from '../action/updateServiceWorkStatus.js';

const mapStateToProps = state => {
  return {
    serviceWorkerStatus: getOperationData(state, ['serviceWorker'], 'status'),
    isPusherOnServiceWorker: getOperationData(
      state,
      ['serviceWorker'],
      'isUsing'
    ),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateServiceWorkStatus: data => dispatch(updateServiceWorkStatus(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceWorkerChores);
